/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FxIdWebFeaturesClientCommandsAckAckItem } from './FxIdWebFeaturesClientCommandsAckAckItem';
import {
    FxIdWebFeaturesClientCommandsAckAckItemFromJSON,
    FxIdWebFeaturesClientCommandsAckAckItemFromJSONTyped,
    FxIdWebFeaturesClientCommandsAckAckItemToJSON,
    FxIdWebFeaturesClientCommandsAckAckItemToJSONTyped,
} from './FxIdWebFeaturesClientCommandsAckAckItem';

/**
 * Запрос на подтверждение выполнения команд
 * @export
 * @interface FxIdWebFeaturesClientCommandsAckRequest
 */
export interface FxIdWebFeaturesClientCommandsAckRequest {
    /**
     * Список команд для подтверждения
     * @type {Array<FxIdWebFeaturesClientCommandsAckAckItem>}
     * @memberof FxIdWebFeaturesClientCommandsAckRequest
     */
    Items: Array<FxIdWebFeaturesClientCommandsAckAckItem>;
}

/**
 * Check if a given object implements the FxIdWebFeaturesClientCommandsAckRequest interface.
 */
export function instanceOfFxIdWebFeaturesClientCommandsAckRequest(value: object): value is FxIdWebFeaturesClientCommandsAckRequest {
    if (!('Items' in value) || value['Items'] === undefined) return false;
    return true;
}

export function FxIdWebFeaturesClientCommandsAckRequestFromJSON(json: any): FxIdWebFeaturesClientCommandsAckRequest {
    return FxIdWebFeaturesClientCommandsAckRequestFromJSONTyped(json, false);
}

export function FxIdWebFeaturesClientCommandsAckRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesClientCommandsAckRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'Items': ((json['Items'] as Array<any>).map(FxIdWebFeaturesClientCommandsAckAckItemFromJSON)),
    };
}

export function FxIdWebFeaturesClientCommandsAckRequestToJSON(json: any): FxIdWebFeaturesClientCommandsAckRequest {
    return FxIdWebFeaturesClientCommandsAckRequestToJSONTyped(json, false);
}

export function FxIdWebFeaturesClientCommandsAckRequestToJSONTyped(value?: FxIdWebFeaturesClientCommandsAckRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Items': ((value['Items'] as Array<any>).map(FxIdWebFeaturesClientCommandsAckAckItemToJSON)),
    };
}

